import React from 'react';
import PropTypes from 'prop-types';
import { Grid as VDSGrid, Row as VDSRow, Col as VDSCol } from '@vds/grids';
import ConditionalWrapper from '../ConditionalWrapper';
import { StyledWrapper } from '../styles';
import QuickLinks from '../QuickLinks';
import { isWHW, isWHWP2 } from '../Helpers';

const FWAContainer = ({ children, enableLiveSupport, renderQuickLinks, title, ...otherProps }) => {
  const childrens = [];
  if (!otherProps.hideLinks) {
    childrens.push(
      <VDSRow>
        <VDSCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
          <QuickLinks title={title} enableLiveSupport={!(isWHW() || isWHWP2()) && enableLiveSupport} renderQuickLinks={renderQuickLinks} />
        </VDSCol>
      </VDSRow>,
    );
  }
  if (!otherProps.noChildren) {
    childrens.push(children);
  }
  return (
    <ConditionalWrapper
      useWrapper={otherProps.topBufferAuto}
      wrapper={(childElements) => (
        <StyledWrapper
          isOverride={otherProps.hideLinks}
          className={`mainViewContainer ${otherProps.hideLinks ? 'overrideLeftSlot' : ''} ${otherProps.noChildren ? 'noChildren' : ''}`}
        >
          {childElements}
        </StyledWrapper>
      )}
    >
      <VDSGrid {...otherProps}>{childrens}</VDSGrid>
    </ConditionalWrapper>
  );
};

FWAContainer.propTypes = {
  topBufferAuto: PropTypes.bool,
  enableLiveSupport: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.oneOf([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  renderQuickLinks: PropTypes.oneOf([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
};

export { FWAContainer, VDSRow as Row, VDSCol as Col };
export default FWAContainer;
